/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_SubInputs */

const en_cp_cal_sub = /** @type {(inputs: Cp_Cal_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4–6 hours per week per person. Fits a 2–3 credit project course or an independent-study module.`)
};

const id_cp_cal_sub = /** @type {(inputs: Cp_Cal_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4–6 jam per minggu per orang. Pas untuk mata kuliah proyek 2–3 SKS atau MBKM Proyek Independen.`)
};

/**
* | output |
* | --- |
* | "4–6 hours per week per person. Fits a 2–3 credit project course or an independent-study module." |
*
* @param {Cp_Cal_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_sub = /** @type {((inputs?: Cp_Cal_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_sub(inputs)
	return en_cp_cal_sub(inputs)
});